import actions from '../../actions/AccidentBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Accident', actions.show.main, actions.show.reset)
